import { cmApiUrl } from '@atc/cm-api-url';
import getFetchOptions from './utils/getFetchOptions.js';
import fetchJSON from './utils/fetchJSON.js';
const fallback = {
  error: 'Circuit Breaker for /rest/retailing/incentive is open',
  rates: {}
};
const options = {
  circuitBreaker: {
    id: 'paymentIncentives',
    timeout: 7000,
    resetTimeout: 300000,
    fallback
  },
  headers: {
    'X-fwd-svc': 'atc'
  }
};
function getPaymentIncentivesFetcher(path) {
  return {
    path: path + cmApiUrl('rest/retailing'),
    async fetch() {
      let queryString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      try {
        const endpoint = `${this.path}/incentives`;
        queryString = queryString.startsWith('?') ? queryString : `?${queryString}`;
        const data = await fetchJSON(endpoint + queryString, getFetchOptions(options));
        return data;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching payment incentives data: ', error);
        return {};
      }
    }
  };
}
export { getPaymentIncentivesFetcher as default };
